import classNames from 'classnames';

const STAR_PATH =
  'M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27Z';

function StarShape({
  sizeClassName,
  fill,
  stroke,
  strokeWidth,
}: {
  sizeClassName?: string;
  fill: string;
  stroke?: string;
  strokeWidth?: number;
}): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames('block text-campaign/yellow-2', sizeClassName)}
      aria-hidden="true"
    >
      <path d={STAR_PATH} fill={fill} stroke={stroke} strokeWidth={strokeWidth} />
    </svg>
  );
}

interface RatingStarIconProps {
  fill: number;
  sizeClassName?: string;
}

function RatingStarIcon({
  fill,
  sizeClassName = 'size-4',
}: RatingStarIconProps): JSX.Element {
  const clampedFill = Math.min(Math.max(fill, 0), 100);
  return (
    <span className={classNames('relative inline-block shrink-0', sizeClassName)}>
      <StarShape
        sizeClassName={sizeClassName}
        fill="white"
        stroke="currentColor"
        strokeWidth={1.5}
      />
      {clampedFill > 0 && (
        <span
          className="absolute inset-y-0 left-0 overflow-hidden"
          style={{ width: `${clampedFill}%` }}
        >
          <StarShape sizeClassName={sizeClassName} fill="currentColor" />
        </span>
      )}
    </span>
  );
}

export default RatingStarIcon;
